import UnnatiTree from '../../icons/UnnatiTree.svg';
import Krishna from '../../assets/meet-the-team/krishna.jpeg';
import Mihika from '../../assets/meet-the-team/mihika.jpeg';
import Aditya from '../../assets/meet-the-team/aditya.jpeg';

export const TestimonialsArray = [
  {
    img: Aditya,
    alt: 'S. ADITYA',
    name: 'S. ADITYA',
    job: 'Project Head, Unnati',
    info: `The ability to do excellent service is dependent on perseverance and patience in the face of obstacles." It doesn't matter whether you have the resources to do well by others, what matters is your ability to rise from within and go above and beyond.`,
  },
  {
    img: Mihika,
    alt: 'MIHIKA AGGARWAL',
    name: 'MIHIKA AGGARWAL',
    job: 'Co-head, Courses Team',
    info:
      'He can who thinks he can, and he can’t who thinks he can’t. This is an inexorable, indisputable law.” This beautiful quote by Pablo Picasso motivates me to think out of the box and follow the path of diligence to accomplish my coveted goals.',
  },
  {
    img: Krishna,
    alt: 'KRISHNAGOPAL KEDIA',
    name: 'KRISHNAGOPAL KEDIA',
    job: 'Co-head, PR Team',
    info:
      'The Pessimist Sees Difficulty In Every Opportunity. The Optimist Sees Opportunity In Every Difficulty.”  This quote is what keeps me going and gives me strength to face any difficulties with grace.',
  },
];

export const TestimonialCardOne = {
  img: UnnatiTree,
  alt: '',
  name: 'LOREM IPSUM',
  job: 'LOREM',
  info: '',
};

export const TestimonialCardTwo = {
  img: UnnatiTree,
  alt: '',
  name: 'LOREM IPSUM',
  job: 'LOREM',
  info: '',
};
export const TestimonialCardThree = {
  img: UnnatiTree,
  alt: '',
  name: 'LOREM IPSUM',
  job: 'LOREM',
  info: '',
};
export const TestimonialCardFour = {
  img: UnnatiTree,
  alt: '',
  name: 'LOREM IPSUM',
  job: 'LOREM',
  info: '',
};
export const TestimonialCardFive = {
  img: UnnatiTree,
  alt: '',
  name: 'LOREM IPSUM',
  job: 'LOREM',
  info: '',
};
export const TestimonialCardSix = {
  img: UnnatiTree,
  alt: '',
  name: 'LOREM IPSUM',
  job: 'LOREM',
  info: '',
};
